import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';


export class PublicHttpService {

	public baseUrl: string;

	constructor(private http: Http) {
		this.baseUrl = process.env.GATEWAY_URL;
	}

	public getBaseUrl(): string {
		return this.baseUrl;
	}

	public get(url: string, options?: RequestOptions) {
		let reqOptions = {};
		if (options) {
			reqOptions = {
				search: options
			};
		}
		return this.http.get(this.baseUrl + url, new RequestOptions(reqOptions));
	}

	public post(url: string, body: string, options?: RequestOptions) {
		let reqOptions = {};
		if (options) {
			reqOptions = {
				search: options
			};
		}
		return this.http.post(this.baseUrl + url, body, new RequestOptions(reqOptions));
	}

	public put(url: string, body: string, options?: RequestOptions) {
		let reqOptions = {};
		if (options) {
			reqOptions = {
				search: options
			};
		}
		return this.http.put(this.baseUrl + url, body, new RequestOptions(reqOptions));
	}

	public patch(url: string, body: string, options?: RequestOptions) {
		let reqOptions = {};
		if (options) {
			reqOptions = {
				search: options
			};
		}
		return this.http.patch(this.baseUrl + url, body, new RequestOptions(reqOptions));
	}

	public delete(url: string, options?: RequestOptions) {
		let reqOptions = {};
		if (options) {
			reqOptions = {
				search: options
			};
		}
		return this.http.delete(this.baseUrl + url, new RequestOptions(reqOptions));
	}
static ctorParameters() { return [ { type: Http } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/public-http.service.ts